import { Modal } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { PlanningLevelConfig } from 'api/resource-management/types';
import { ReactComponent as AllocationChangeArrow } from 'assets/svgs/allocation-change-arrow.svg';
import { ReactComponent as HoursPerDay } from 'assets/svgs/day-level-allocation.svg';
import { ReactComponent as HoursPerWeek } from 'assets/svgs/week-level-allocation.svg';
import { useTranslation } from 'hooks/use-translation';

const StyledModal = styled(Modal)`
  .ant-modal-header {
    border: none;
  }
  .ant-modal-content {
    width: 40rem;
  }
  .ant-modal-footer {
    margin-top: var(--spacing-07);
    padding: var(--spacing-05);
  }
  .ant-modal-title {
    font-size: var(--heading-5-size);
  }

  .ant-modal-body {
    padding: 0 var(--spacing-06);
  }
`;

const ArrowWrapper = styled.div`
  margin-top: -1.5rem;
  display: flex;
  justify-content: center;
`;

const ExampleImagesWrapper = styled.div`
  margin-top: var(--spacing-05);
  display: flex;
  gap: var(--spacing-05);
`;

interface Props {
  show: boolean;
  setShow: (show: boolean) => void;
  onConfirm: (value: PlanningLevelConfig) => void;
  isLoading: boolean;
}

export const AllocationSettingsModal: FC<Props> = ({
  show,
  setShow,
  onConfirm,
  isLoading,
}) => {
  const modalTitle = useTranslation(
    'settings.resource_management.allocation_type.modal.title',
  );

  return (
    <StyledModal
      visible={show}
      onOk={() => {
        onConfirm(PlanningLevelConfig.HoursPerWeek);
      }}
      onCancel={() => {
        setShow(false);
      }}
      title={modalTitle}
      okText={useTranslation(
        'settings.resource_management.planning_level.modal.confirmation',
      )}
      confirmLoading={isLoading}
    >
      <FormattedMessage
        id="settings.resource_management.allocation_type.modal.description"
        values={{
          b: (chunks) => <b>{chunks}</b>,
        }}
      />

      <ExampleImagesWrapper>
        <HoursPerDay alt="hours per day allocation example" />
        <HoursPerWeek alt="hours per week allocation example" />
      </ExampleImagesWrapper>

      <ArrowWrapper>
        <AllocationChangeArrow alt="allocation change arrow" />
      </ArrowWrapper>
      <FormattedMessage id="settings.resource_management.allocation_type.modal.confirmation" />
    </StyledModal>
  );
};
